import type { AvatarPreferences } from '@/types/avatar'

export type MembershipTier = 'free' | 'plus' | 'club'

/** Coerce arbitrary server input to a known tier; unknown/empty -> free. */
export function normalizeMembershipTier(value: unknown): MembershipTier {
  return value === 'plus' || value === 'club' ? value : 'free'
}

export interface PlayerProfile {
  email: string
  name: string
  picture: string
  avatarPreferences: AvatarPreferences
  gamesPlayed: number
  gamesWon: number
  totalScore: number
  createdAt: string
  lastActiveAt: string
  preferredTeamId?: string | null
  membershipTier: MembershipTier
}
